<template>
  <div>
    <h1>Page not found!</h1>
  </div>
</template>
<script>
import { clearTokens, getTokensFromPath, storeTokensInSession } from '@/TokenUtils.ts'
export default {
  methods: {
    handleLoginLogout: function () {
      console.log(this.$route)
      if (window.location.pathname === '/login/callback') {
        console.log('logging in...')
        // This is a login callback. Let's look for tokens!
        storeTokensInSession(getTokensFromPath(this.$route.path))
        this.$router.push('/')
        // TODO: redirect
      } else if (window.location.pathname === '/logout/callback') {
        console.log('logging out...')
        clearTokens()
        // TODO: redirect
      }
    }
  },
  beforeMount: function () {
    this.handleLoginLogout()
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Catchall.vue